import React, {Component} from 'react'
import UserListItem from '../UserListItem/index'

class UserList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {users: props.users};
    }

    render() {
        return <ul>{this.props.users.map(user => <UserListItem user={user}></UserListItem>)}</ul>;
    }
}

export default UserList;


// WEBPACK FOOTER //
// ./src/components/base/UserList/index.js